/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Začetna stran',
	homePageTabsLabel: 'Domača vsebina',
	myContent: 'Moja vsebina',
	teamContent: 'Vsebina ekipe',
	folder: 'Mapa',
	files: 'Datoteke',
	actionMenu: 'Meni Dejanja',
	myFolder: 'Moje mape',

	emptyFolderNoContent: 'Ni vsebine',

	//EmptyStates
	emptyRecentTitle: 'Nedavno si niste ogledali nobene vsebine.',
	emptyStateTitle: 'Začnite z dodajanjem podatkov',
	emptyStateBody: 'Zgoraj kliknite Naloži podatke ali povlecite in spustite, da naložite podatke.',
	emptySearchResultTitle: 'Iskanje ni vrnilo rezultatov.',
	emptyPortalTitle: 'Ni portalov',
	emptyPortalBody: 'Trenutno nimate nobenih portalov.',
	emptyWsProjectTitle: 'Začnite s tem, da ustvarite beležnico v programu Watson Studio.',
	emptyWsProjectBody: 'Ko se vrnete v Cognos Analytics, bo beležnica prikazana tukaj.',
	emptyFilteredResultTitle: 'Uveljavljeni filtri niso vrnili rezultatov.',
	emptyDialogViewTitle: 'Ni postavk',
	removeFromRecents: 'Odstrani iz nedavnih',

	// Welcome Banner
	welcomeBannerGreeting: 'Pozdravljeni. Dobrodošli v Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson omogoča uporabnikom samopostrežno analitiko na osnovi umetne inteligence. Oglejte si, kako lahko avtomatizirana priprava podatkov, odkrivanje podatkov in vizualizacije vodijo do sprejemanja bolj samozavestnih odločitev.',
	welcomeBannerDescription_trialUser: 'Začnete lahko takoj, in sicer tako, da si ogledate predstavitveni video, predstavitev izdelka in zavihek Prvi koraki.',
	takeTourButtonLabel: 'Ogled izdelka',
	watchVideoButtonLabel: 'Ogled videa',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Ali ste prepričani, da želite izklopiti pozdravno pasico na začetni strani? Pasico lahko kadarkoli znova vklopite v možnosti Profil in nastavitve > Nastavitve > Splošno. ',
	hideWelcomeBannerTitle: 'Izklopi pozdravno pasico',
	ok: 'V redu',
	cancel: 'Prekliči',
	warn: 'Opozorilo',
	//howto video dialog
	modal_how_title: 'Ogled pregleda izdelka Cognos Analytics',
	modal_overview_title: 'Ogled pregleda izdelka Cognos Analytics',
	modal_how_play: 'Predvajajo videoposnetek',
	modal_how_video_title_overview: 'Pregled',
	modal_how_video_title_getStarted: 'Prvi koraki v 11.2',
	modal_how_video_title_newUI: 'Dobrodošli v novi izkušnji Cognos',
	modal_how_video_title_dataModule: 'Pregled podatkovnih modulov',
	modal_how_video_title_explore: 'Pregled raziskovanja podatkov',
	modal_how_video_title_dashboard: 'Pregled interaktivnih delovnih tabel',
	modal_how_video_title_reporting: 'Pregled poročanja',
	modal_how_video_title_mobile: 'Moč Cognosa na vaši dlani',

	// Toolbar
	search: 'Iskanje',
	addFolder: 'Dodaj mapo',
	addLink: 'Dodaj povezavo',
	filter: 'Filter',
	sort: 'Razvrsti',
	settings: 'Nastavitve',
	tilesView: 'Pogled ploščic',
	listView: 'Seznamski pogled',
	columnView: 'Pogled stolpcev',
	backToSearch: 'Nazaj na rezultate iskanja',

	// Toolbar Actions
	sortBy: 'Razvrsti po',
	sortOrder: 'Razvrsti',
	name: 'Ime',
	modifiedTime: 'Spremenjeno',
	type: 'Tip',
	ascending: 'Naraščajoče',
	descending: 'Padajoče',
	resetSort: 'Ponastavi razvrščanje',

	filterType: 'Tip',
	filterModificationTime: 'Spremenjeno',
	all: 'Vse',
	today: 'Danes',
	yesterday: 'Včeraj',
	pastWeek: 'Prejšnji teden',
	pastMonth: 'Prejšnji mesec',
	resetFilters: 'Ponastavi filtre',
	resultLimit: 'Omejitev rezultatov',

	filterSearchPlaceHolder: 'Filtriraj po ključnih besedah',

	resetFilterTag: 'Kliknite X, da ponastavite filtre.',
	filterTagToolTip: 'Uveljavljeni filtri: %{appliedFilters}.',

	folderName: 'Ime mape',
	addAFolder: 'Dodaj mapo',
	add: 'Dodaj',
	error: 'Napaka',
	newFolderDefaultName: 'Nova mapa',
	toastCreateNewFolder: 'Mapa %{nameOfFolder} je bila ustvarjena v %{tabName}.',
	folderAdded: 'Mapa je dodana',
	refresh: 'Osveži',
	openFolder: 'Odpri mapo',

	addAUrl: 'Dodaj URL',
	linkName: 'Ime URL-ja',
	linkNamePlaceholder: 'Dodaj ime URL-ja',
	linkDescription: 'Opis (neobvezno)',
	linkDescriptionPlaceholder: 'Dodaj opis',
	linkUri: 'URL',
	linkUriPlaceholder: 'Dodaj URL s sprejemljivo domeno',
	acceptableDomains: 'Sprejemljive domene',
	viewAcceptableDomains: 'Ogled sprejemljivih domen',
	mandatoryField: 'Obvezno polje',
	linkAdded: 'URL je dodan',
	toastCreateNewLink: 'Povezava %{nameOfLink} je bila dodana v %{tabName}.',
	noEntries: 'Na seznamu sprejemljivih domen ni vnosov. Obrnite se na skrbnika.',
	unacceptableDomain: 'Vaš URL uporablja neveljavno domeno. Za prikaz seznama domen, ki jih lahko uporabite, kliknite \'Ogled sprejemljivih domen\'.',

	compact: 'Strnjeno',
	short: 'Kratko',
	default: 'Privzeto',
	rowSize: 'Velikost vrstice',

	// GroupyByTypes
	folders: 'Mape',
	reports: 'Poročila',
	dashboards: 'Delovne table',
	data: 'Podatki',
	packages: 'Paketi',
	explorations: 'Raziskovanja',
	stories: 'Zgodbe',
	notebooks: 'Beležnice',
	others: 'Drugo',

	// Error Messages
	itemsOverLimit: 'Podano ime "%{itemName}" je preseglo največjo omejitev (20). Če želite nadaljevati, podajte drugo ime.',
	errorMessageLengthFolderName: 'Vnesite ime mape, ki ne presega 255 znakov.',
	errorMessageLengthLinkName: 'Vnesite ime povezave, ki ne presega 255 znakov.',
	toastLaunchPerspectiveError: '%{objectType} ni mogoče odpreti.',
	errorNoAccessTitle: 'Ojoj, videti je, da nimate dostopa do te vsebine',
	errorNoAccessBody: 'Obrnite se na skrbnika ali uporabite naslednjo povezavo:',
	errorEnableExternalContent: 'Omogočanje zunanje vsebine',

	//TableHeader
	lastAccessed: 'Zadnji dostop',
	location: 'Lokacija',
	tenant: 'Imetnik',

	// GetStartedTab
	getStartedLabel: 'Začnite z delom v programu IBM Cognos Analytics',
	learningHowToLabel: 'Viri za učenje',
	learningHowToDescription: 'Razširite svoje znanje in si zagotovite pomoč tako, da se povežete s skupnostjo, preberete dokumentacijo in si ogledate videoposnetke.',
	learningHowToActionLabel: 'Zaženi podokno za učenje',
	howToVideosLabel: 'Videoposnetki z nasveti',
	howToVideosDescription: 'Preberite, kako lahko uporabljate IBM Cognos Analytics in začnite dobivati vpoglede v svoje podatke.',
	howToVideosActionLabel: 'Ogled videov',
	acceleratorCatalogLabel: 'Katalog pospeševalnikov',
	acceleratorCatalogDescription: 'Prebrskajte rastoči katalog uporabe v panogi, vodiče po najboljših praksah, vizualizacije po meri in drugo vsebino.',
	acceleratorCatalogActionLabel: 'Prebrskaj katalog',
	sampleSectionTitle: 'Vzorci',
	sampleSectionDescription: 'Eksperimentirajte s primeri, ki prikazujejo vse, kar ponuja Cognos Analytics.',
	// Samples Section
	createDashboardSampleTitle: 'Kako ustvarite prvo delovno tablo',
	createDashboardSampleDescription: 'Začnite popotovanje po analitiki z delovnimi tablami Cognos.',
	nlaSampleTitle: 'Vzorčno poročilo',
	nlaSampleDescription: 'Raziščite, kaj je mogoče s poročili Cognos Analytics s tem primerom analiziranja dejavnosti članov kartice zvestobe ob koncu leta.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Razširite knjižnico vizualizacij z vizualizacijami po meri, kot je na primer grafikon Sankey.',
	viewAllSamplesActionLabel: 'Prikaži vse vzorce',
	byFeatureTitle: 'Po funkciji',
	byFeatureDescription: 'Prebrskajte zglede po funkcijah, kot so osnovna funkcionalnost, kontrolniki po meri, razširitve, beležnice in relativni datumi.',
	byIndustryTitle: 'Po industriji',
	byIndustryDescription: 'Prebrskajte zglede glede na industrijo, kot je avtomobilska industrija, bančne storitve itn. ',
	// SamplesTab
	sampleTabTitle: 'Poiščite navdih v vnaprej zgrajenih vzorcih',
	sampleTabLabel: 'Obiščite Accelerator Catalog za več vzorcev in razširitev od IBM-a, partnerjev in strank. ',

	// quickLaunch
	quickLaunchLabel: 'Hitri zagon',
	expand: 'Razširi',
	collapse: 'Strni',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Začnite s tem, da izberete, kaj želite ustvariti.',

	// contentPageView
	contentPageTitleLabel: 'Vsebina',
	uploadFile: 'Naloži podatke',
	new: 'Novo',
	create: 'Ustvari',
	more: 'Več',

	// open dialog
	selectDataSourcesToAdd: 'Izberite izvore podatkov, ki jih želite dodati.',
	openDialogDefaultTitle: 'Odpri',

	// save dialog
	save: 'Shrani',
	saveAs: 'Shrani kot',
	saving: 'Shranjevanje ...',
	selectedDestination: 'Izbrani cilj: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' že obstaja z različnim tipom. Izberite drugo ime.',
	confirmOverwriteTitle: 'Potrditev zamenjave obstoječih podatkov',
	confirmOverwriteMsg: 'Datoteka \'%{nameOfFile}\' že obstaja. Ali želite zamenjati njene podatke s podatki v izbrani datoteki?',

	// copy move dialog
	copy: 'Prekopiraj',
	move: 'Premakni',
	copyOrMove: 'Prekopiraj ali premakni: ',
	copyOnly: 'Prekopiraj ',
	createShortcut: 'Ustvari bližnjico',
	createShortcutDialogTitle: 'Ustvari bližnjico: ',

	// External asset types
	wsProject: 'Projekt Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paket',
	dataModule: 'Podatkovni modul',
	exploration: 'Raziskovanje',
	mode: 'Način',
	live: 'V živo',
	snapshot: 'Posnetek',
	noSnapshotsFound: 'Ni najdenih posnetkov',
	uploadedFile: 'Naložena datoteka',
	fileUpload: 'Naloži podatke',
	dataSetEx: 'Nabor podatkov',
	externalRepository: 'Zunanji repozitorij',
	queryMode: 'Poizvedbeni način',
	queryModeCompatible: 'Združljivo',
	queryModeDynamic: 'Dinamično',
	report: 'Poročilo',
	activeReport: 'Aktivno poročilo',
	query: 'Poizvedba',
	analysis: 'Analiza',
	dashboard: 'Delovna tabla',
	dashboardTemplate: 'Predloga delovne table',
	jupyterNotebook: 'Beležnica',
	wsNotebook: 'Beležnica Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Zgodba',
	workspace: 'Delovni prostor',
	pagelet: 'Stran',
	content: 'Vsebina',
	directory: 'Imenski prostori',
	dataSet: 'Nabor podatkov',
	powerPlayCube: 'Kocka PowerPlay',
	powerPlayReport: 'Poročilo PowerPlay',
	powerPlay8Report: 'Poročilo PowerPlay',
	setPowerPlay8ReportOptions: 'Nastavi možnosti poročila PowerPlay',
	powerPlay8ReportView: 'Pogled poročila PowerPlay',
	reportTemplate: 'Predloga poročila',
	packageConfigurations: 'Konfiguracija paketa',
	agent: 'Agent',
	agentDefinition: 'Definicija agenta',
	agentDefinitionView: 'Pogled agenta',
	dataMovementTask: 'Naloga premikanja podatkov',
	dataMovementTaskAlias: 'Vzdevek naloge premikanja podatkov',
	document: 'Dokument',
	DocumentRetention: 'Lastnosti dokumenta',
	jobDefinition: 'Definicija opravila',
	job: 'Opravilo',
	jobs: 'Opravila',
	metricsDataSourceETLTask: 'Naloga ETL za izvor podatkov metrik',
	metricsExportTask: 'Naloga izvoza metrike',
	metricsFileImportTask: 'Naloga uvoza datoteke metrik',
	metricsMaintenanceTask: 'Naloga vzdrževanja metrike',
	planningTask: 'Naloga načrtovanja',
	shortcut: 'Bližnjica',
	shortcuts: 'Bližnjice',
	URL: 'URL',
	launchable: 'Ima možnost zagona',
	dataSetFolder: 'Mapa nabora podatkov',
	ViewAccessibleLabel: 'Prikaži %{label}',
	overrideReportOptions: 'Preglasi privzete možnosti poročila',
	formats: 'Oblike',
	saveReport: 'Shrani poročilo',
	reportView: 'Pogled poročila',
	reportviews: 'Pogledi poročil',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Podatki Excel',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Vloga',
	namespace: 'Imenski prostor',
	namespaceFolder: 'Mapa imenskega prostora',
	adminFolder: 'Skrbniška mapa',
	//Details
	details: 'Podrobnosti',
	open: 'Odpri',
	created: 'Ustvarjeno',
	modified: 'Spremenjeno',
	owner: 'Lastnik',
	dataSource: 'Izvor podatkov',
	share: 'Daj v skupno rabo',
	addToFavorites: 'Dodaj med priljubljene',
	properties: 'Lastnosti',
	detailsEmptyStateBody: 'Izberite postavko, da si ogledate njene podrobnosti',
	editNameAndDescription: 'Urejanje imena in opisa',
	none: 'Brez',
	setPdfOptions: 'Nastavi možnosti PDF',
	runOptions: 'Možnosti izvajanja',

	//rename dialog
	nameInvalid: 'Ime ni veljavno',
	namePlaceholder: 'Vnesite ime',
	description: 'Opis',
	descriptionInvalid: 'Opis ne sme vsebovati več kot 350 znakov.',
	descriptionPlaceholder: 'Vnesite opis',
	errorMessageApostropheError: 'Vnesite ime datoteke, ki ne vsebuje obeh znakov \' in ".',
	renameCollisionError: '%{name} že obstaja. Poskusite z drugim imenom.',
	unknownRenameError: 'Preimenovanje postavke ni uspelo. Za dodatno pomoč se obrnite na skrbnika.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Podane mape ni mogoče odpreti.',

	//Upload
	uploadToFolder: "Naloži v <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Naloži v <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> in zaženite %{launchAction}",
	quickUpload: "Hitro nalaganje",
	quickUploadAndLaunch: "Povlecite datoteke in jih spustite, da jih naložite v <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> ter odprete v enem od naslednjih prostorov.",
	unsupportedFilesSingle: "Datoteka %{files} se ni naložila, ker ni veljavna za hitri zagon.",
	unsupportedFilesMultiple: "Datoteke se niso naložile, ker morajo biti vse datoteke, ki jih izberete, veljavne za hitri zagon.",
	unsupportedFilesSingleInvalid: "Datoteka %{files} ni veljavna.",
	unsupportedFilesMultipleInvalid: "Datoteke %{files} niso veljavne.",
	supportedFileTypes: "Dovoljeni so samo naslednji tipi datotek: %{extensions}.",
	uploadDragAndDrop: "Povleci in spusti",
	uploadDragAndDropMessage: "Povlecite datoteko in ko spustite tukaj, da jo naložite v <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Kriteriji iskanja \'%{searchTerm}\' so bili shranjeni.',
	searchWasntSaved: 'Kriteriji iskanja \'%{searchTerm}\' niso bili shranjeni.',
	searchSuggestions: 'Predlogi',
	savedSearch: 'Shranjena iskanja',
	searchWasDeleted: 'Kriteriji iskanja \'%{searchTerm}\' so bili izbrisani.',
	searchWasntDeleted: 'Kriteriji iskanja \'%{searchTerm}\' niso bili izbrisani.',
	savedBarTitle: 'Iskanje v Cognos Analytics',
	searchContentPageTitle: 'Iskanje',
	searchContentPageTitleLabel: 'Prikazovanje rezultatov za \'%{searchTerm}\'',
	showingSearchRsult: 'Prikazovanje toliko postavk: %{resultCount}',
	saveSearch: 'Shrani iskanje',
	saveTenSearches: 'Shranite lahko 10 iskanj.',
	deleteASearch: 'Izbrišite iskanje, da lahko shranite drugo.',
	close: 'Zapri',
	allContent: 'Vsa vsebina',
	searchResultIn: 'Rezultati iskanja v: ',
	//recent view
	recents: 'Nedavno',
	noAccessRecent: 'Nimate dostopa',
	noAccessRecentMsg: 'Nimate dostopa do tega sredstva. Sredstvo je bilo morda onemogočeno ali izbrisano ali pa so bila vaša dovoljenja zmanjšana. Preverite stanje sredstva na njegovi pričakovani izvorni lokaciji. Sredstvo lahko odstranite iz nedavnih postavk tako, da kliknete V redu.',
	noAccessMsg: 'Nimate dostopa do tega sredstva. Sredstvo je bilo morda onemogočeno ali izbrisano ali pa so bila vaša dovoljenja zmanjšana.',

	//contextToolbar
	itemsSelected: 'Št. izbranih postavk: %{nameOfSelection}',
	itemSelected: '%{nameOfSelection} izbrana postavka',

	//properties
	general: 'Splošno',
	schedule: 'Urnik',
	permission: 'Dovoljenja',
	capabilities: 'Zmožnosti',
	propertiesTabsLabel: 'Vsebina lastnosti',
	searchPath: 'Iskalna pot',
	id: 'ID',
	language: 'Jezik',
	setLanguage: 'Nastavi jezik',
	entryOptions: 'Možnosti vnosa',
	setPackage: 'Nastavi paket ali modul',
	sourcePackage: 'Izvorni paket ali podatkovni modul',
	associatedSourceAgent: 'Izvorni paket',
	setAssociatedSourceAgent: 'Nastavi paket',
	sourceAgent: 'Izvorni agent',
	setSourceAgent: 'Nastavi izvornega posrednika',
	setCapabilities: 'Nastavljanje zmožnosti',
	disableEntry: 'Onemogoči ta vnos',
	hideEntry: 'Skrij ta vnos',
	permissions: 'Dovoljenja',
	promptForValues: 'Poziv za vrednosti',
	yes: 'Da',
	no: 'Ne',
	setValues: 'Nastavi vrednosti',
	moreOptions: 'Več možnosti',
	reportFormat: 'Oblika zapisa poročila',
	enableAccessibilitySupport: 'Omogoči podporo za ljudi s posebnimi potrebami',
	displayOfRunHistory: 'Prikaz zgodovine izvajanja',
	occurrences: 'Pojavitve',
	days: 'Dnevi',
	months: 'Meseci',
	displayOfReportOutputVersions: 'Prikaz različice izhodnih podatkov poročila',
	defaultDisplayOfPortalAction: 'Privzeto dejanje portala',
	viewMostRecentReport: 'Prikaži najnovejše poročilo',
	runTheReport: 'Zaženi poročilo',
	openWithReportStudio: 'Odpri s programom Report Studio',
	rowsPerPageInHtmlReports: 'Vrstic na stran v poročilih HTML',
	enableSelectionBasedInteractivity: 'Omogoči interaktivnost na osnovi izbora',
	enableAlertsAboutNewVersions: 'Omogoči opozorila o novih različicah',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Omogoči izboljšane uporabniške funkcije v shranjenih različicah izhodnih podatkov',
	enableCommentsInSavedOutputVersions: 'Omogoči komentarje v shranjenih različicah izhodnih podatkov',
	run: 'Zaženi',
	runWithUsersCredentials: 'S poverilnicami uporabnika',
	runWithOwnerCapabilities: 'Z zmožnostjo lastnika',
	runAsOwner: 'Ko %{ownerName}',
	actionLabelOn: 'Vklopljeno',
	actionLabelOff: 'Izklopljeno',
	openReport: 'Urejanje',
	openAnalysis: 'Odpri s programom Analysis Studio',
	openQuery: 'Odpri s programom Query Studio',
	openPowerPlay8Report: 'Odpri s programom PowerPlay Studio',
	openInteractiveReport: 'Urejanje',
	read: 'Preberi',
	write: 'Piši',
	execute: 'Izvedi',
	setPolicy: 'Ustvari pravilnik',
	full: 'Polno',
	traverse: 'Prečkaj',
	grant: 'Odobri',
	deny: 'Zavrni',
	permissionCustom: 'Po meri',
	permissionDetailsColumnAccess: 'Dostop',
	permissionDetailsColumnPermission: 'Dovoljenje',
	permissionDetailsColumnAction: 'Dejanje',
	permissionSetAccess: 'Nastavi dostop',
	permissionRead: 'Preberi',
	permissionRun: 'Zaženi',
	permissionWrite: 'Piši',
	permissionFull: 'Polno',
	unavailable: 'Ni na voljo',
	unkownSource: 'Neznano, za podrobnosti odprite poročilo.',
	tenantSettings: 'Nastavitve imetnika',
	tenantSet: 'Imetnik je bil posodobljen',
	tenantSetError: 'Napaka pri nastavljanju imetnika',
	tenantClear: 'Imetnik je bil počiščen',
	tenantClearError: 'Napaka pri čiščenju imetnika',
	shortcutTo: 'Bližnjica do',
	sourceReport: 'Izvorno poročilo',
	setSourceReport: 'Nastavi izvorno poročilo',
	setSourceLocation: 'Nastavi lokacijo za izvor%{itemName}Lokacija',
	linkPackageOrModule: 'Poveži%{itemName} s paketom ali podatkovnim modulom',
	linkPackage: 'Poveži%{itemName} s paketom',
	externalRepositories: 'Zunanji repozitoriji',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Osveženo',
	size: 'Velikost',
	tenantsWarningMessage: 'Če spremenite imetnika vnosa, se spremeni tudi imetnik podrejenih vnosov.',
	confirmClearTenantText: 'Če počistite vrednost na \'Brez\', lahko drugim najemnikom omogočite dostop do vsebine. Kliknite V redu, da naredite vnos javen, ali Prekliči, da ohranite trenutnega imetnika.',
	confirmClearTenant: 'Potrdi čiščenje imetnika',
	currentValues: 'Trenutne vrednosti',
	emptyPromptValues: 'Trenutno ni nobene vrednosti',
	editValues: 'Urejanje vrednosti',
	clear: 'Počisti',
	source: 'Izvor',
	dataRefreshed: 'Podatki so osveženi',
	//PDF options
	pdfOptions: 'Možnosti PDF',
	set: 'Nabor',
	portrait: 'Pokončno',
	landscape: 'Ležeče',
	letter: 'Letter',
	legal: 'Legal',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Usmerjenost',
	pageDefination: 'Velikost papirja',
	openPasswordRequired: 'Zahtevaj geslo za odpiranje poročila',
	accessPasswordRequired: 'Zahtevaj geslo za dostop do poročila',
	emptyPassword: 'Geslo ne sme biti prazno',
	password: 'Geslo',
	enterPassword: 'Vnesite geslo',
	confirmPassword: 'Potrdite geslo',
	passwordMatchError: 'Gesli se ne ujemata',
	gateway: 'Prehod',
	pageLayout: 'Postavitev strani',
	pageStyle: 'Slog',
	setUrl: 'Nastavi URL',
	numberRows: 'Število vrstic',
	numberColumns: 'Število stolpcev',
	timeToRefresh: 'Čas do osvežitve',
	lastRefreshedBy: 'Osvežil je',
	unknown: 'Neznano',
	unknownUpdateError: 'Posodobitev postavke ni uspela. Za dodatno pomoč se obrnite na skrbnika.',
	editQuery: 'Urejanje poizvedbe',
	greaterOrEqual: 'Večje od ali enako %{upperboundValue}',
	lessOrEqual: 'Manjše od ali enako %{lowerboundValue}'
});
